/**
 * @deprecated since version 3.0.0
 */
export function Autoregister() {
    return (target): any => {
        /**/
    };
}
